import { Nullable } from '@tager/web-core';

import { BlogCategory, SEOTemplate } from '@/typings/model';

import { TextObject } from './types';

export const convertText = (category: BlogCategory, numberValue?: number) => {
  const text: TextObject = {
    reviews: {
      1: 'Найден 1 обзор',
      2: 'Найдено 2 обзора',
      3: 'Найдено 3 обзора',
      4: 'Найдено 4 обзора',
      default: 'Найдено {n} обзоров',
    },
    offers: {
      1: 'Найдена 1 акция',
      2: 'Найдено 2 акции',
      3: 'Найдено 3 акции',
      4: 'Найдено 4 акции',
      default: 'Найдено {n} акций',
    },
    news: {
      1: 'Найдена 1 новость',
      2: 'Найдено 2 новости',
      3: 'Найдено 3 новости',
      4: 'Найдено 4 новости',
      default: 'Найдено {n} новостей',
    },
    brand: {
      1: 'Найден 1 бренд',
      2: 'Найдено 2 бренда',
      3: 'Найдено 3 бренда',
      4: 'Найдено 4 бренда',
      default: 'Найдено {n} брендов',
    },
  };
  const categoryText = text[category];

  if (categoryText && numberValue) {
    const message = categoryText[numberValue] || categoryText.default;
    return message.replace('{n}', numberValue.toString());
  }

  return '';
};

export const getSinglePostSEO = (
  title: string,
  image: string,
  seoTemplate: Nullable<SEOTemplate>
): Nullable<SEOTemplate> => {
  if (!seoTemplate) {
    return null;
  }

  const { title: seoTitle, description, openGraphImage } = seoTemplate;

  const replaceText = (text: Nullable<string>): Nullable<string> => {
    return text?.replaceAll('{{title}}', title) ?? text;
  };

  return {
    ...seoTemplate,
    title: replaceText(seoTitle),
    description: replaceText(description),
    openGraphImage: openGraphImage ?? image,
  };
};
